import React, { Fragment, useState } from "react";
import Modal from "../Modal/modal";
import Code from "../Code/Code";
import PuffLoader from "react-spinners/PuffLoader";
import useDataBrands from "../../../hooks/useDataBrands";

const Card = () => {
  const { dataBrands } = useDataBrands();
  const [show, setShow] = useState(true);
  const [modalData, setModalData] = useState("");
  const [showCode, setShowCode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [credentialNumber, setCredentialNumber] = useState("");
  const [credentialStatus, setCredentialStatus] = useState();
  const [couponData, setCouponData] = useState();

  const mostrarModal = async (dataBrands) => {
    setShow(true);
    setLoading(true);
    setModalData(dataBrands);
    setLoading(false);
  };

  const cerrarTodo = () => {
    setShowCode(false);
    setShow(false);
    setModalData("");
    setCouponData("");
    setCredentialStatus(null);
    setCredentialNumber("");
  };

  return (
    <Fragment>
      {dataBrands?.map((item, index) => {
        return (
          <Fragment key={index}>
            <div className="ccard">
              <div className="main-card">
                <div className="image">
                  <img
                    src={
                      item?.logo
                        ? `https://comerciosclub.lavoz.com.ar/${item.logo}`
                        : ""
                    }
                    alt={item.description}
                  />
                </div>
                <div className="description-card">
                  <div className="align-between">
                    <h2>{item?.nombre_marca}</h2>
                    <h4>{item?.descuento ? item?.descuento + "%" : ""}</h4>
                  </div>
                  <p>{item.descripcion}</p>
                  <button
                    className="btn btn-white"
                    onClick={() => mostrarModal(item)}
                  >
                    Obtener mi código
                  </button>
                </div>
              </div>
            </div>
            {item.name === modalData?.name && show && modalData && (
              <section className="modal-father">
                <Modal
                  show={show}
                  setShow={setShow}
                  setShowCode={setShowCode}
                  setCredentialStatus={setCredentialStatus}
                  loading={loading}
                  modalData={modalData}
                  setCredentialNumber={setCredentialNumber}
                  credentialNumber={credentialNumber}
                  setCouponData={setCouponData}
                  couponData={couponData}
                  setLoading={setLoading}
                />
              </section>
            )}
            {(showCode && modalData && couponData && credentialStatus === 0) ||
            (showCode && modalData && credentialStatus === undefined) ? (
              <section className="code-father">
                <Code showCode={showCode} setShowCode={setShowCode}>
                  {loading ? (
                    <div className="align-center">
                      <PuffLoader
                        size={75}
                        color={"#F32A24"}
                        loading={loading}
                      />
                    </div>
                  ) : (
                    <>
                      <button
                        className="modal-close btn btn-white btn-border-none align-end"
                        id="close"
                        onClick={() => {
                          cerrarTodo();
                        }}
                      >
                        X
                      </button>
                      <div className="image">
                        <img
                          src={`https://comerciosclub.lavoz.com.ar/${modalData?.logo}`}
                          alt={modalData?.description}
                        />
                      </div>
                      <div className="modal-info">
                        <p>
                          Tu Número de credencial no tiene descuentos o es
                          incorrecta
                        </p>
                      </div>
                      <button
                        className="btn btn-white align-center"
                        onClick={() => {
                          cerrarTodo();
                        }}
                      >
                        Cerrar
                      </button>
                    </>
                  )}
                </Code>
              </section>
            ) : null}
            {showCode &&
            modalData &&
            couponData &&
            credentialStatus === 1 &&
            couponData.cupon[0] !== null ? (
              <section className="code-father">
                <Code showCode={showCode} setShowCode={setShowCode}>
                  {loading ? (
                    <div className="align-center">
                      <PuffLoader
                        size={75}
                        color={"#F32A24"}
                        loading={loading}
                      />
                    </div>
                  ) : (
                    <>
                      <button
                        className="modal-close btn btn-white btn-border-none align-end"
                        id="close"
                        onClick={() => {
                          cerrarTodo();
                        }}
                      >
                        X
                      </button>
                      <div className="image">
                        <img
                          src={`https://comerciosclub.lavoz.com.ar/${modalData?.logo}`}
                          alt={modalData.description}
                        />
                      </div>
                      <div className="modal-info">
                        <p className="bolder">Tu código de descuento:</p>
                        <div className="align-between show-code">
                          <h3>{couponData?.cupon[0].codigo_landing}</h3>
                          <button
                            value="Copiar código de descuento"
                            className="btn btn-blue"
                          >
                            Copiar
                          </button>
                        </div>
                      </div>
                      <div className="modal-info">
                        <p>Utiliza tu código de descuento INGRESANDO ACÁ</p>
                      </div>
                      <button
                        className="btn btn-white align-center"
                        onClick={() => cerrarTodo()}
                      >
                        Cerrar
                      </button>
                    </>
                  )}
                </Code>
              </section>
            ) : null}
          </Fragment>
        );
      })}
    </Fragment>
  );
};

export default Card;
